/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_OutInputs */

const en_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom out`)
};

const fr_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom arrière`)
};

const de_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herauszoomen`)
};

const it_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimpicciolisci`)
};

const ru_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отдалиться`)
};

const es_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alejar`)
};

const zh_cn2_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩小`)
};

const ja_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズームアウト`)
};

const hi_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम आउट`)
};

const pt_pt2_zoom_out = /** @type {(inputs: Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuir o zoom`)
};

/**
* | output |
* | --- |
* | "Zoom out" |
*
* @param {Zoom_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_out = /** @type {((inputs?: Zoom_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_zoom_out(inputs)
	if (locale === "de") return de_zoom_out(inputs)
	if (locale === "it") return it_zoom_out(inputs)
	if (locale === "ru") return ru_zoom_out(inputs)
	if (locale === "es") return es_zoom_out(inputs)
	if (locale === "zh-CN") return zh_cn2_zoom_out(inputs)
	if (locale === "ja") return ja_zoom_out(inputs)
	if (locale === "hi") return hi_zoom_out(inputs)
	if (locale === "pt-PT") return pt_pt2_zoom_out(inputs)
	return en_zoom_out(inputs)
});